import { useState, useCallback } from 'react';
import { positionsAPI } from '../api/services';

export function usePositions() {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadPositions = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await positionsAPI.getAll();

      // Handle different response formats
      setPositions(response.positions || response.data || response || []);
    } catch (err) {
      console.error('Error loading positions:', err);
      setError(err.message);
      setPositions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const createPosition = useCallback(async (data) => {
    try {
      setLoading(true);
      setError(null);
      const response = await positionsAPI.create(data);
      return { success: true, position: response.position || response };
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || 'Error al crear cargo';
      setError(errorMsg);
      return { success: false, error: errorMsg };
    } finally {
      setLoading(false);
    }
  }, []);

  const updatePosition = useCallback(async (id, data) => {
    try {
      setLoading(true);
      setError(null);
      const response = await positionsAPI.update(id, data);
      return { success: true, position: response.position || response };
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || 'Error al actualizar cargo';
      setError(errorMsg);
      return { success: false, error: errorMsg };
    } finally {
      setLoading(false);
    }
  }, []);

  const deletePosition = useCallback(async (id) => {
    try {
      setLoading(true);
      setError(null);
      await positionsAPI.delete(id);
      return { success: true };
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || 'Error al eliminar cargo';
      setError(errorMsg);
      return { success: false, error: errorMsg };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    positions,
    loading,
    error,
    loadPositions,
    createPosition,
    updatePosition,
    deletePosition
  };
}

export default usePositions;
